import { TableRenderer, TableRenderType } from "./table-renderer";
import { JsonItem } from "../../../secure/list-management/scripts/list-management.objects";
import _ from "lodash";

export class DataViewer {
    propertyName: string;
    displayName: string;
    propertyType: DataViewType;
    pickListId: string;

    tableRenderer: TableRenderer;
    pickLists: JsonItem[];

    constructor(propertyName: string, propertyType: DataViewType, displayName: string, pickListId: string = undefined) {
        this.propertyName = propertyName;
        this.propertyType = propertyType;
        this.displayName = displayName;
        this.pickListId = pickListId;
    }

    initialize(pickLists: JsonItem[]) {
        this.pickLists = pickLists;
        this.tableRenderer = new TableRenderer(this.pickLists);
    }

    getDisplayValue(obj: any): string {
        let rawVal = _.get(obj, this.propertyName);

        if (this.propertyType == DataViewType.String) {
            return rawVal;
        }
        else if (this.propertyType == DataViewType.MultilineString) {
            let regex: RegExp = /(\n|\r|\r\n)/g;
            let strVal = <string>rawVal;
            strVal = strVal.replace(regex, "<br/>");
            return strVal;
        }
        else if (this.propertyType == DataViewType.StringArray) {
            if ((<string[]>rawVal)?.length > 0) {
                return (<string[]>rawVal)?.join(", ");
            }
        }
        else if (this.propertyType == DataViewType.Number) {
            return rawVal;
        }
        else if (this.propertyType == DataViewType.PipePathSeparatedIds) {
            return this.tableRenderer.renderDisplay(rawVal, TableRenderType.PipePathSeparatedIds, this.pickListId);
        }
        else if (this.propertyType == DataViewType.NumberId) {
            return this.tableRenderer.renderDisplay(rawVal, TableRenderType.Number, this.pickListId);
        }
        else if (this.propertyType == DataViewType.Boolean) {
            if (rawVal) {
                return "Yes";
            }
            else {
                return "No";
            }
        }
        else if (this.propertyType == DataViewType.Date) {
            return this.tableRenderer.renderDate(rawVal);
        }

        return ""
    }
}

export enum DataViewType {
    String,
    MultilineString,
    StringArray,
    Number,
    NumberId,
    PipePathSeparatedIds,
    Boolean,
    Date
}